/**
 * FormsModuleSettingsService
 * Module-wide Forms settings singleton.
 * Route: forms/api/forms/module-settings
 */
import { BaseService } from '../base/BaseService';
/** Service for the FormsSetting singleton (get / update). */
export class FormsModuleSettingsService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? FormsModuleSettingsService.DEFAULT_SERVICE_PATH,
            basePath: FormsModuleSettingsService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** GET api/forms/module-settings */
    async get() {
        const response = await this.getRaw();
        if (!response.data)
            throw new Error('Forms module settings not found');
        return response.data;
    }
    getRaw() {
        return this.http.get(this.buildUrl());
    }
    /** PUT api/forms/module-settings */
    async update(settings) {
        const response = await this.updateRaw(settings);
        if (!response.data)
            throw new Error('Failed to update Forms module settings');
        return response.data;
    }
    updateRaw(settings) {
        return this.http.put(this.buildUrl(), settings);
    }
}
FormsModuleSettingsService.DEFAULT_SERVICE_PATH = 'forms';
FormsModuleSettingsService.BASE_PATH = 'api/forms/module-settings';
//# sourceMappingURL=FormsModuleSettingsService.js.map